<template>
  <div class="loadingsec" v-if="showLoading">
    <svg
      class="spinner"
      width="65px"
      height="65px"
      viewBox="0 0 66 66"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        class="path"
        fill="none"
        stroke-width="6"
        stroke-linecap="round"
        cx="33"
        cy="33"
        r="30"
      ></circle>
    </svg>
  </div>
  <div v-else>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <table class="basic-tbl" id="colored-table">
              <thead>
                <tr>
                  <th style="width: 10%">{{ $t("RequesterName") }}</th>
                  <th style="width: 14%">{{ $t("RequesterUsername") }}</th>
                  <th style="width: 10%">{{ $t("Departman") }}</th>
                  <th style="width: 13%">{{ $t("DeliveryDate") }}</th>
                  <th style="width: 13%">{{ $t("CreateOn") }}</th>

                  <th style="width: 40%">{{ $t("Description") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="width: 10%">
                    {{ model.requesterInfo ? model.requesterInfo.name : "-" }}
                  </td>
                  <td style="width: 14%">
                    {{
                      model.requesterInfo ? model.requesterInfo.userName : "-"
                    }}
                  </td>
                  <td style="width: 10%">
                    {{ model.departmentUnit ? model.departmentUnit.name : "-" }}
                  </td>
                  <td style="width: 20%">
                    <date-picker
                      v-model="model.persianDeliveryClock"
                      type="datetime"
                      format="jYYYY-jMM-jDD HH:mm:ss"
                      display-format="jYYYY-jMM-jDD HH:mm:ss"
                      id="date-picker"
                      class="z-50"
                      :label="$t('DeliveryDate')"
                      name="date"
                      :disabled="editable"
                    />
                  </td>
                  <td style="width: 13%">
                    {{ model.persianCreateOn ? model.persianCreateOn : "-" }}
                  </td>
                  <td style="width: 33%">
                    <vs-input
                      v-model="model.description"
                      name="Description"
                      :label="$t('Description')"
                      :disabled="editable"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-card mt-5">
      <div class="vx-card__body card-body">
        <form v-if="editClicked">
          <div class="vx-row">
            <div class="vx-col lg:w-1/4 sm:w-1/2 w-full my-2">
              <vs-input
                v-model="productName"
                name="productName"
                :label="$t('ProductName')"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('productName')"
                >{{ errors.first("productName") }}</span
              >
            </div>
            <div class="vx-col lg:w-1/4 sm:w-1/2 w-full my-2">
              <vs-input
                v-model="modelNumber"
                name="modelNumber"
                :label="$t('ModelNumber')"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('modelNumber')"
                >{{ errors.first("modelNumber") }}</span
              >
            </div>
            <div class="vx-col lg:w-1/4 sm:w-1/2 w-full my-2">
              <label class="vs-select--label">{{ $t("Unit") }}</label>
              <v-select
                class="m-0"
                label="name"
                name="unit"
                :options="allUnits"
                v-model="unit"
                v-validate="{ required: true }"
                dir="rtl"
              >
              </v-select>
              <span class="text-danger text-sm" v-show="errors.has('unit')">{{
                errors.first("unit")
              }}</span>
            </div>
            <div class="vx-col lg:w-1/4 sm:w-1/2 w-full my-2">
              <vs-input v-model="amount" name="amount" :label="$t('Amounts')" />
              <span class="text-danger text-sm" v-show="errors.has('amount')">{{
                errors.first("amount")
              }}</span>
            </div>
          </div>
          <div class="mt-5 w-full flex items-end mb-2 justify-end">
            <vs-button
              type="filled"
              :disabled="!amount || !unit || !productName || !modelNumber"
              @click.prevent="addProduct"
              >{{ $t("Add") }}</vs-button
            >
          </div>
        </form>
        <div class="vx-row mt-5">
          <div
            class="vx-col w-full mb-base"
            v-if="model.purchaseItems && model.purchaseItems.length > 0"
          >
            <vs-table :data="model.purchaseItems" class="custom-tbl">
              <template slot="thead">
                <th style="width: 5%">#</th>
                <th style="width: 10%">{{ $t("ProductName") }}</th>
                <th style="width: 14%">{{ $t("ModelNumber") }}</th>
                <th style="width: 10%">{{ $t("Unit") }}</th>
                <th style="width: 13%">{{ $t("Amounts") }}</th>
                <th style="width: 10%">{{ $t("Action") }}</th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr v-for="(row, index) in data" :key="index">
                  <vs-td>
                    {{ index + 1 }}
                  </vs-td>
                  <vs-td style="width: 25%">
                    <vs-input
                      v-model="row.productName"
                      name="productName"
                      :disabled="editable"
                    />
                  </vs-td>
                  <vs-td style="width: 20%">
                    <vs-input
                      v-model="row.modelNumber"
                      name="modelNumber"
                      :disabled="editable"
                    />
                  </vs-td>
                  <vs-td style="width: 15%">
                    <v-select
                      class="m-0"
                      label="name"
                      name="unit"
                      :options="allUnits"
                      v-model="row.unitOfMeasuresName"
                      :reduce="(x) => x.name"
                      v-validate="'required'"
                      dir="rtl"
                      :disabled="editable"
                    ></v-select>
                  </vs-td>
                  <vs-td style="width: 20%">
                    <vs-input
                      v-model="row.count"
                      name="amount"
                      :disabled="editable"
                    />
                  </vs-td>
                  <vs-td>
                    <vs-button
                      radius
                      color="danger"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-x"
                      @click.prevent="deleteProduct(index)"
                      class="d-inline"
                    ></vs-button>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <div class="flex justify-end w-full ml-4">
            <vs-button v-if="editClicked" type="filled" @click.prevent="save">
              <span> {{ $t("Save") }}</span>
            </vs-button>
            <vs-button v-else type="filled" @click.prevent="edit">
              <span> {{ $t("Edit") }}</span>
            </vs-button>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-end w-full ml-4 mt-10">
      <vs-button type="filled" color="danger" @click.prevent="reject">
        <span> {{ $t("Reject") }}</span>
      </vs-button>
      <vs-button
        type="filled"
        color="success"
        class="mr-5"
        @click.prevent="accept"
      >
        <span> {{ $t("Close") }}</span>
      </vs-button>
    </div>
  </div>
</template>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import vSelect from "vue-select";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "warehouseManagement_CheckinTransactions_Details",
  components: {
    "v-select": vSelect,
  },
  data() {
    var id = this.$route.params.id;

    return {
      allUnits: [],
      headerInfo: {},
      model: {},
      editable: true,
      editClicked: false,
      productName: "",
      modelNumber: "",
      amount: null,
      showLoading: false,
      unit: {},
    };
  },
  //   computed: {
  //     ...mapGetters({
  //       headerInfo: "purchaseRequest/details",
  //     }),
  //   },
  mounted() {
    this.showLoading = true;
    var id = this.$route.params.id;
    this.fetchPurchaseRequest(id).then((r) => {
      this.model = r;
      this.fetchUnits().then((r) => {
        this.allUnits = r;
        this.showLoading = false;
      });
    });
  },
  methods: {
    ...mapActions({
      fetchPurchaseRequest: "purchaseRequest/fetchPurchaseRequest",
      editPurchaseRequest: "purchaseRequest/editPurchaseRequest",
      acceptPurchaseRequest: "purchaseRequest/acceptPurchaseRequest",
      rejectRequest: "purchaseRequest/rejectRequest",
      fetchUnits: "unit/fetchList",
    }),

    edit() {
      this.editable = false;
      this.editClicked = true;
    },
    addProduct() {
      const product = {
        productName: this.productName,
        modelNumber: this.modelNumber,
        unitOfMeasuresName: this.unit.name,
        count: this.amount,
      };
      this.model.purchaseItems.push(product);
    },
    save() {
      const payload = {
        id: this.model.id,
        deliveryClock: this.model.persianDeliveryClock,
        description: this.model.description,
        purchaseItems: this.model.purchaseItems,
      };
      this.editPurchaseRequest(payload).then((r) => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "درخواست خرید مورد نظر ویرایش شد",
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          this.editable = true;
          this.editClicked = false;
        });
      });
    },
    deleteProduct(index) {
      this.$swal({
        position: "center-center",
        text: "آیا از حذف این آیتم اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.model.purchaseItems.splice(index, 1);
        }
      });
    },
    reject() {
      this.$swal({
        position: "center-center",
        text: "آیا از رد این درخواست اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.rejectRequest({ id: this.model.id }).then((r) => {
            this.$swal({
              position: "center-center",
              type: "danger",
              text: "سفارش خرید مورد نظر رد شد",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.$router.go(-1);
            });
          });
        }
      });
    },
    accept() {
      this.acceptPurchaseRequest({ id: this.model.id }).then((r) => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "سفارش خرید مورد نظر تایید شد",
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          this.$router.go(-1);
        });
      });
    },
  },
};
</script>
